/* istanbul ignore file */
import { RemediationTaskApprovalStatus } from "stan-client";

export const isRejected = (status?: RemediationTaskApprovalStatus): boolean =>
  status === "rejected";
